export enum ApprovalStatus {
    Default = "Default",
    Pending = "Pending",
    Approved = "Approved",
    Declined = "Declined"
}